export function handleClientContactForm() {
    let submitBtn = document.querySelector('.sub-site-body #wpforms-submit-925');
    if (!submitBtn) {
        return;
    }
    let lang;
    var queryString = window.location.search;
    var urlParams = new URLSearchParams(queryString);
    if (urlParams.has('lang')) {
        lang = urlParams.get('lang');
    } else {
        lang = 'en';
    }
    if (lang == 'tc' || lang == 'sc') {
        submitBtn.setAttribute('data-alt-text', '提交中...');
        (submitBtn as HTMLElement).innerText = '提交';
    }
    else if (lang == 'ja') {
        submitBtn.setAttribute('data-alt-text', '提出する...');
        (submitBtn as HTMLElement).innerText = '提出する';
    }
}